import React, {PureComponent} from 'react';
import {FastField, FieldArray, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import get from 'lodash/get';
import classNames from 'classnames';
import messages from '../../../../../res/translations/messages';
import FormGroup from '../FormGroup';
import CommonFields from './CommonFields';
import MultipleNumber3RowType from './MultipleNumber3RowType';
import Error from '../../../Error';

class MultipleNumber3Type extends PureComponent {
    constructor(props) {
        super(props);
        this.onMaxUpdate = this.onMaxUpdate.bind(this);
    }

    onMaxUpdate(e) {
        const {name, form} = this.props;
        const intVal = parseInt(e.currentTarget.value) || 0;
        // this is needed or the value won't be updated to the field
        form.setFieldValue(`${name}.max`, intVal > 0 ? intVal : '');
    }

    render() {
        const {name, form, previousPages} = this.props;

        return (
            <>
                <CommonFields name={name} form={form} required={true} previousPages={previousPages} />
                <div className="row">
                    <FormGroup name={`${name}.max`} label={messages.surveys.form.label.max} size={3} tooltip={messages.surveys.form.tooltip.max}>
                        <FastField id={`${name}.max`} name={`${name}.max`} type="number" step="any" onChange={this.onMaxUpdate} required
                            className={classNames('form-control',
                                {error: get(form.errors, `${name}.max`) && get(form.touched, `${name}.max`)})} />
                        <ErrorMessage name={`${name}.max`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                    </FormGroup>
                </div>
                <div className="form-group">
                    <h4>
                        &gt; <FormattedMessage {...messages.surveys.form.label.rows} />
                    </h4>
                    <FieldArray name={`${name}.rows`} component={MultipleNumber3RowType} previousPages={previousPages} />
                    <ErrorMessage name={`${name}.rows`}>{(message) => <Error reason={message.key} reasonParams={message.params} />}</ErrorMessage>
                </div>

            </>
        );
    }
}

export default MultipleNumber3Type;
